import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 我的家庭教师",
    description: "抱歉，你访问的页面不存在，请返回首页继续浏览影视内容。",
    keywords: "页面不存在,我的家庭教师",
    path: location.pathname,
  });

  return (
    <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <p className="font-heading text-7xl font-bold text-background-300 md:text-9xl">
        404
      </p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        页面不存在
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的路径 {location.pathname} 未找到对应内容
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
        >
          <i className="ri-home-4-line text-base"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="flex h-10 items-center whitespace-nowrap rounded-md border border-background-300/60 px-5 text-sm text-foreground-800 transition-colors hover:text-foreground-950"
        >
          搜索影视
        </Link>
      </div>
    </div>
  );
}